/* ScandLights cart: drawer in the live (Debutify) look on Dawn's <cart-drawer> interface (product-form.js adds
   to it and asks it to re-render), quantity/remove in the drawer and on /cart. */
(() => {
  const body = document.body;
  const SECTION = 'sl-cart-drawer';

  class SlCartDrawer extends HTMLElement {
    connectedCallback() {
      document.addEventListener('click', (e) => {
        if (e.target.closest('.js-drawer-open-button-right')) { e.preventDefault(); this.open(); return; }
        if (e.target.closest('.js-cart-drawer-close') || (this.contains(e.target) && e.target.closest('.js-drawer-close'))) { this.close(); return; }
        const btn = this.contains(e.target) && e.target.closest('.qty-adjust, .cart__product-remove');
        if (btn) {
          e.preventDefault();
          const line = +btn.dataset.line;
          const input = this.querySelector(`.qty-input[data-line="${line}"]`);
          const q = btn.classList.contains('cart__product-remove') ? 0 : Math.max(0, (+input.value || 0) + (btn.classList.contains('qty-plus') ? 1 : -1));
          this.change(line, q);
        }
      });
      this.addEventListener('change', (e) => { if (e.target.classList.contains('qty-input')) this.change(+e.target.dataset.line, Math.max(0, +e.target.value || 0)); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    }
    open() {
      body.classList.add('js-drawer-open', 'js-drawer-open-right');
      this.classList.add('js-drawer-open'); this.setAttribute('aria-hidden', 'false');
    }
    close() {
      body.classList.remove('js-drawer-open', 'js-drawer-open-right');
      this.classList.remove('js-drawer-open'); this.setAttribute('aria-hidden', 'true');
    }
    getSectionsToRender() { return [{ id: SECTION }]; }
    setActiveElement(el) { this.activeElement = el; }
    /* Dawn product-form passes the /cart/add.js response with sections[] attached */
    renderContents(parsed) {
      if (parsed && parsed.sections && parsed.sections[SECTION]) this.swap(parsed.sections[SECTION]);
      this.open();
    }
    swap(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const form = doc.querySelector('#ajaxCartForm');
      if (!form) return;
      this.querySelector('#CartContainer').replaceChildren(form);
      const n = +form.dataset.cartCount;
      document.querySelectorAll('.cart-count').forEach((c) => { c.textContent = n; });
      document.querySelectorAll('.cart-link__bubble').forEach((b) => b.classList.toggle('cart-link__bubble--visible', n > 0));
    }
    async change(line, quantity) {
      this.classList.add('ajaxcart--is-loading');
      try {
        const r = await fetch(`${window.routes.cart_change_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity, sections: [SECTION], sections_url: location.pathname }) });
        const j = await r.json();
        if (j.sections && j.sections[SECTION]) this.swap(j.sections[SECTION]);
      } finally { this.classList.remove('ajaxcart--is-loading'); }
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', SlCartDrawer);

  /* /cart page: quantity buttons/inputs update the line and reload (remove is a plain link, like live) */
  const page = document.getElementById('cartForm');
  if (page) {
    const set = async (line, quantity) => { await fetch(`${window.routes.cart_change_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) }); location.reload(); };
    page.addEventListener('click', (e) => {
      const btn = e.target.closest('.qty-adjust'); if (!btn) return;
      e.preventDefault();
      const input = page.querySelector(`.qty-input[data-line="${btn.dataset.line}"]`);
      set(+btn.dataset.line, Math.max(0, (+input.value || 0) + (btn.classList.contains('qty-plus') ? 1 : -1)));
    });
    page.addEventListener('change', (e) => { if (e.target.classList.contains('qty-input')) set(+e.target.dataset.line, Math.max(0, +e.target.value || 0)); });
  }
})();
